/**
 * @generated SignedSource<<47ef04b6724c851e2f292061d62423a2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftMarketSortAndFilter_search$data = {
  readonly facets: ReadonlyArray<{
    readonly facetField: string | null;
    readonly facetValues: ReadonlyArray<{
      readonly count: number | null;
      readonly value: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "NftMarketSortAndFilter_search";
};
export type NftMarketSortAndFilter_search$key = {
  readonly " $data"?: NftMarketSortAndFilter_search$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftMarketSortAndFilter_search">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftMarketSortAndFilter_search",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItemSearchFacet",
      "kind": "LinkedField",
      "name": "facets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "facetField",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftItemSearchFacetValue",
          "kind": "LinkedField",
          "name": "facetValues",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItemSearchConnection",
  "abstractKey": null
};

(node as any).hash = "3bd4b498974c7bdfa78afda349cd6f3f";

export default node;
